import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import PPSICreate from './PumpSpareInternational/Create';
import PAMDCreate from './AraiManufacturing/Create';

function PCreate() {
  const [purchasetype, setpurchasetype] = useState('');
  const [purchasecategory, setpurchasecategory] = useState('');
  const [purchasetypeDisabled, setpurchasetypeDisabled] = useState(false);
  const [purchasecategoryDisabled, setpurchasecategoryDisabled] = useState(false);

  const handlepurchasetypeChange = (event) => {
    const selectedpurchasetype = event.target.value;
    setpurchasetype(selectedpurchasetype);
    setpurchasecategory('');
    setpurchasecategoryDisabled(false);
    setpurchasetypeDisabled(true);

    if (selectedpurchasetype === 'Manufacturing') {
      setpurchasecategory('Domestic');
      setpurchasecategoryDisabled(true);
    }

    if (selectedpurchasetype === 'Pump Spare') {
      setpurchasecategory('International');
      setpurchasecategoryDisabled(true);
    }
  };

  const handlepurchasecategoryChange = (event) => {
    setpurchasecategory(event.target.value);
    setpurchasecategoryDisabled(true);
  };

  const PageDisplay = () => {
    if (purchasetype === 'Pump Spare' && purchasecategory === 'International') {
      return <PPSICreate />;
    }
    if (purchasetype === 'Manufacturing') {
      return <PAMDCreate />;
    }
    return null;
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>ADD PURCHASE</h6>
          <Link to="/pindex/1">
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select
                  onChange={handlepurchasetypeChange}
                  value={purchasetype}
                  disabled={purchasetypeDisabled}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {purchasetype === 'Pump Spare' && (
              <Col md="6">
                <Form.Group>
                  <Form.Label>PO Category:</Form.Label>
                  <Form.Control value="International" disabled />
                </Form.Group>
              </Col>
            )}
            {purchasetype === 'Manufacturing' && (
              <Col md="6">
                <Form.Group>
                  <Form.Label>PO Category:</Form.Label>
                  <Form.Control value="Domestic" disabled />
                </Form.Group>
              </Col>
            )}
            {PageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default PCreate;
